"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var i0 = require("@angular/core");
var i1 = require("@angular/router");
var ActionGuard = /** @class */ (function () {
    function ActionGuard(router) {
        this.router = router;
    }
    ActionGuard.prototype.canActivate = function (next, state) {
        console.log("ValidateEmailGuard");
        console.log(next);
        console.log(state);
        var action = next.queryParams["action"];
        var code = next.queryParams["code"];
        if (action == "validate-email" && code) {
            console.log("ValidateEmailGuard: true");
            var url = this.router.createUrlTree(["/validate-email"], { queryParams: { code: code } });
            console.log(url);
            this.router.navigateByUrl(url);
            return true;
        }
        return true;
    };
    ActionGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ActionGuard_Factory() { return new ActionGuard(i0.ɵɵinject(i1.Router)); }, token: ActionGuard, providedIn: "root" });
    return ActionGuard;
}());
exports.ActionGuard = ActionGuard;
